import React, { Component, Fragment, useEffect, useState } from "react";
import "./style.css";
import {
  Layout,
  Menu,
  Spin,
  Table,
  Button,
  Space,
  Input,
  Row,
  Col,
  Divider,
  Tabs,
  Switch,
  Dropdown,
  Card, Avatar,
  Form,
  Popover,
  Select,
  Breadcrumb,
  List,
  message,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  SyncOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Container from "../../Layout/Container";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import InfiniteScroll from 'react-infinite-scroller';
import { getAllUsers, viewAlluserSelector, fetchUserData, clearState } from './DDsAndAdsViewAlluserSlice';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const { Meta } = Card;
const ntop = "none";
const nbottom = "bottomCenter";
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { Option } = Select;

export default function ViewAllUser() {


  const dispatch = useDispatch();
  let history = useHistory()

  const [isLoading, setLoading] = React.useState(false);

  const { isFetching, isSuccess, isError, errorMessage, viewAlluser, userCount } = useSelector(
    viewAlluserSelector
  );

  const [viewallUserData, setDataSource] = useState([]);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('All');

  const [loading, setDataLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getAllUsers(1));
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);

      toast.error(errorMessage);

    }
    if (isSuccess) {
      setLoading(false);
      setDataSource(viewAlluser);
    }
  }, [isError, isSuccess, setLoading, viewAlluser, setDataSource]);

  const handleInfiniteOnLoad = () => {
    let data = viewallUserData;
    // console.log('u data cnt = ' + data.length + ' ucount=' + userCount)
    if (data.length > userCount) {
      message.warning('Infinite List loaded all');
      setDataLoading(false);
      setHasMore(false);
      return;
    }

    dispatch(fetchUserData(page + 1)).then(res => {
      data = data.concat(res.data.filteredUsers);

      setDataLoading(false);
      setHasMore(false);
      setDataSource(data);
      let newpage = page + 1;
      setPage(newpage);
      // this.setState({
      //   data,
      //   loading: false,
      // });
    });
  };


  let dataSource = isLoading
    ? []
    : viewallUserData ? viewallUserData : [];

  dataSource = dataSource ? dataSource.slice().sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) : [];

  const handleChangeFilter = (v) => {
    setTypeFilter(v);
    if (search) {
      let filterType = search ? 'all=true' : '';
      if (v == 'All') {
        filterType = search ? '&all=true' : '';
      }
      else {
        filterType = search ? '&other=' + v : '';
      }
      let s = search ? '&search=' + search : '';
      let d = search ? '&departmentName=Chief of Air Staff' : '';
      let q = 1 + filterType + s + d;
      // console.log(q)
      dispatch(fetchUserData(q)).then(res => {
        // console.log(res)
        let udata = res.data.filteredUsers;
        setDataSource(udata);
        setPage(1);
        setDataLoading(false);
        setHasMore(true);
      });

    } else {
      let q = '';
      if (v == 'All') {
        q = 1;
      }
      else {
        q = 1 + '&other=' + v + '&departmentName=Chief of Air Staff';
      }

      dispatch(fetchUserData(q)).then(res => {
        // console.log(res)
        let udata = res.data.filteredUsers;
        setDataSource(udata);
        setPage(1);
        setDataLoading(false);
        setHasMore(true);
      });


    }
    // if(search){
    //   let filterType = 'all=true';
    //   if(v=='All'){
    //     filterType = '&all=true';
    //   }
    //   else{
    //     filterType = '&other='+v;
    //   }
    //   let s = '&search='+search;
    //   let d = '&departmentName=Chief of Air Staff';
    //   let q = 1+filterType+s+d;
    //   //console.log('fchange '+v)
    //   //console.log(q)
    //   //setPage(1);
    //   //dispatch(getAllUsers(q));

    //   dispatch(fetchUserData(q)).then(res => {
    //     let udata = res.data.filteredUsers;
    //     setDataSource(udata);
    //     setPage(1);
    //     setDataLoading(false);
    //     setHasMore(true);
    //   });

    // }
    // else {
    //   // setPage(1);
    //   // dispatch(getAllUsers(1));
    //   dispatch(fetchUserData(1)).then(res => {
    //     let udata = res.data.filteredUsers;
    //     setDataSource(udata);
    //     setPage(1);
    //     setDataLoading(false);
    //     setHasMore(true);
    //   });
    // }

  }


  //   const goToProfile = (row) => {
  //     history.push({
  //       pathname: '/view-user',
  //      // search: '?query=abc',
  //       state: { username:row.username }
  //   });
  // }

  return (
    <>
      {/* <div className="demo-infinite-container" style={{ height: "calc(100vh - 10px)", overflow: "auto"}}>
      <InfiniteScroll
        initialLoad={false}
        pageStart={0}
        loadMore={handleInfiniteOnLoad}
        hasMore={!loading && hasMore}
        useWindow={false}
      > */}
      <Container >
        {/* <Breadcrumb style={{ margin: '25px 0',paddingLeft:50,marginBottom:0 }} separator=">">
        <Breadcrumb.Item><Link to="/manage-users">Manage </Link></Breadcrumb.Item>
        <Breadcrumb.Item>View All Users</Breadcrumb.Item>
      </Breadcrumb> */}



        <div
          className="site-layout-content"
          style={{ marginTop: 5, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isFetching} />
            <h2
              style={{
                paddingLeft: 30,
                paddingTop: 20,
                borderTop: "1px solid #dfe0eb",
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                marginBottom: 0,
                backgroundColor: '#ffffff'
              }}
            >
              All Users  ({userCount})
            </h2>
            <Space
              style={{
                padding: "16px 30px",
                width: "100%",
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                backgroundColor: '#ffffff'
              }}
              size="large"
            >
              <Row style={{ width: "100%" }}>
                <Col span="16 " >
                  {/* <Search placeholder="Search process"  size="large"  /> */}
                  {/* <Input
                    placeholder="Search name"
                    size="large"
                    suffix={<SearchOutlined />}
                    onChange={e => {
                      const currValue = e.target.value;
                      setSearch(currValue);
                      const filteredData = viewAlluser.filter(entry =>
                        entry.name.includes(currValue)
                      );
                      setDataSource(filteredData);
                    }}
                  /> */}
                  <Row style={{ width: '100%' }} gutter={16}>
                    <Col className="gutter-row" span={16} >
                      <Input placeholder="Search by Name" size="large" suffix={<SearchOutlined />}
                        onChange={e => {
                          const currValue = e.target.value;
                          setSearch(currValue);
                          // const filteredData = viewAlluser.filter(entry =>
                          //   entry.name.includes(currValue)
                          // );
                          //setDataSource(filteredData);
                          let filterType = 'all=true';
                          if (typeFilter == 'All') {
                            filterType = '&all=true';
                          }
                          else {
                            filterType = '&other=' + typeFilter;
                          }
                          let s = '&search=' + currValue;
                          let d = '&departmentName=Chief of Air Staff';
                          let q = 1 + filterType + s + d;
                          // console.log(q)
                          if (currValue) {
                            // setPage(1);
                            // dispatch(getAllUsers(q));
                            dispatch(fetchUserData(q)).then(res => {
                              let udata = res.data.filteredUsers;
                              setDataSource(udata);
                              setPage(1);
                              setDataLoading(false);
                              setHasMore(true);
                            });
                          }
                          else {

                            // setPage(1);
                            // dispatch(getAllUsers(1));
                            dispatch(fetchUserData(1)).then(res => {
                              let udata = res.data.filteredUsers;
                              setDataSource(udata);
                              setPage(1);
                              setDataLoading(false);
                              setHasMore(true);
                              // console.log('data count=' + viewallUserData.length + ' ucount=' + userCount + ' page=' + page)
                            });
                          }

                        }} />
                    </Col>

                    <Col className="gutter-row" span={8}>
                      <Select
                        id={'filtersearch'}
                        // labelInValue={true}
                        optionLabelProp="label"
                        placeholder={
                          <React.Fragment>
                            Filter By
                          </React.Fragment>
                        }
                        defaultValue={typeFilter}
                        style={{ width: '100%' }}
                        onChange={handleChangeFilter}>
                        <Option label='Filter By Type (All)' value="All">All</Option>
                        <Option label='Filter By Type (Clerk)' value="Clerk">Clerk</Option>
                        <Option label="Filter By Type (DD's & AD's)" value="DD's %26 AD's" >DD's & AD's</Option>
                        <Option label='Filter By Type (CHD)' value="CHD">CHD</Option>
                      </Select>
                    </Col>

                  </Row>
                </Col>
                <Col span="5" ></Col>
              </Row>
            </Space>

            <Space
              style={{
                padding: "16px 30px",
                width: "100%",
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                backgroundColor: '#ffffff'
              }}
              size="large"
            >


              <Row>
                <Col span="24">
                  {/* <Form.Item>
                              <h2
                                style={{
                                  fontWeight: "bold",
                                  fontStyle: "normal",
                                  fontSize: 20,
                                }}
                              >
                                DEPARTMENT OF AIR INTELLIGENCE
                              </h2>
                            </Form.Item> */}
                  <Row>
                    {/* <div className="demo-infinite-container" style={{ height: "calc(100vh - 50px)", overflow: "auto" }}> */}
                    <div className="demo-infinite-container" style={{ height: "calc(100vh - 50px)", overflow: "auto", border: 'none', padding: 0 }}>
                      <InfiniteScroll
                        initialLoad={false}
                        pageStart={page}
                        loadMore={handleInfiniteOnLoad}
                        hasMore={!loading && hasMore}
                        useWindow={false}
                      >
                        <List
                          //grid={{ gutter: 16, column: 3 }}
                          grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 2,
                            md: 2,
                            lg: 3,
                            xl: 3,
                            xxl: 3,
                          }}
                          dataSource={dataSource}
                          renderItem={item => (
                            <List.Item>
                              <Card className="custom-card-css" style={{ padding: 2 }}>
                                <Popover content={item.name} placement="top" trigger="hover">
                                  <Meta
                                    avatar={
                                      <Avatar src={item.profilePic.length > 0 || item.profilePic != '' ? item.profilePic : 'images/user.png'} />
                                    }
                                    title={<a style={{ color: 'inherit', cursor: "default" }}>{item.name}</a>}

                                    //  description="Assistant Director"
                                    description={[
                                      <div>
                                        <p className="custom-sub-heading">{item.roleName}</p>
                                        <p className="custom-no">{item.phone}</p>
                                      </div>
                                    ]}
                                    className="custom-img"
                                  />
                                </Popover>
                              </Card>
                            </List.Item>
                          )}
                        >

                          {loading && hasMore && (
                            <div className="demo-loading-container">
                              <Spin />
                            </div>
                          )}

                        </List>
                      </InfiniteScroll>
                    </div>
                  </Row>

                  {/* <Row className="custom-row-cards">
                              

                              {dataSource.map((item,key)=>{
                                return (<>
                                <Col span="8" key={key}>
                                <Card className="custom-card-css" style={{cursor:"pointer"}}>
                                <Popover content={item.name} placement="top" trigger="hover">
                                  <Meta
                                    avatar={
                                      <Avatar src={item.profilePic.length > 0 || item.profilePic!=''?item.profilePic:'images/user.png'} />
                                    }
                                    title={item.name}
                                  
                                  //  description="Assistant Director"
                                    description={[
                                      <div>
                                          <p className="custom-sub-heading">{item.role}</p>
                                          <p className="custom-no">{item.phone}</p>
                                      </div>
                                    ]}
                                    className="custom-img"
                                  />
                                  </Popover>
                                </Card>
                                </Col>
                               </>
                               );
                                })}
                       
                         </Row> */}

                </Col>

              </Row>

            </Space>









          </div>
        </div>

      </Container>
      {/* </InfiniteScroll>
        </div> */}
    </>
  );
}
